<img
  class="cursor-pointer"
  src="assets/images/logo/Logo COLOR pqms.png"
  routerLink="/"
/>
